const topics = [
  { label: '#暑期档观影指南', count: '12.8万' },
  { label: '#被窝网电影推荐', count: '9.6万' },
  { label: '#高分悬疑电影', count: '8.3万' },
  { label: '#科幻电影必看', count: '7.5万' },
  { label: '#国产动画崛起', count: '6.9万' },
  { label: '#韩剧推荐清单', count: '6.2万' },
  { label: '#周末观影计划', count: '5.7万' },
  { label: '#经典电影重温', count: '5.1万' },
  { label: '#纪录片精选', count: '4.6万' },
  { label: '#追剧达人必备', count: '4.2万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-2">Topics</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            影迷们正在热议的话题，加入讨论发现更多好片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((t) => (
            <div
              key={t.label}
              className="group flex items-center gap-3 px-5 py-3 bg-background-100 rounded-full border border-background-200/60 cursor-pointer hover:border-accent-300/40 hover:bg-accent-50 transition-all duration-200"
            >
              <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{t.label}</span>
              <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                {t.count} 讨论
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}